import Request from './request'
import store from "../store";
import snackbar from '@/plugins/snackbar';
import i18n from '@/i18n';

async function fetch(data){
    return Request("get","api/finance-bills/index",data)
}

async function fetchOne(id,data){
    return Request("get","api/finance-bills/view/" + id,data )
}

async function fetchAllForSelect(data) {
    // if (!data) data = {};
    // data.limit = consts.limitAll; //获取全部
    // data.fieldFilter = ["id","area_name"]; //仅筛选少许必要字段
    return Request('get', "api/finance-bills/getFinanceMaterialCategories", data);
}

async function edit(id,data){
    return Request("post","api/finance-bills/edit/" + id,data )
}


async function fetchBatchEdit(id,data){
    return Request("get","api/finance-bills/get-finance-material-list?finance_bill_ids=" + id,data )
}

async function fetchByMaterial(id,ids){
    return Request("get","api/finance-bills/get-finance-details-by-material?material_id=" + id + "&finance_bill_ids=" + ids)
}

async function batchEdit(data){
    return Request("post","api/finance-bills/batch-edit/",data )
}

// 批量导出
async function exportExcel(data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/finance-bills/batch-detail-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

// 详情导出
async function exportDetail(id){
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/finance-bills/detail-export/" + id);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}


export default {
    fetch,
    fetchOne,
    fetchBatchEdit,
    fetchAllForSelect,
    edit,
    fetchByMaterial,
    batchEdit,
    exportExcel,
    exportDetail
}